import { Fragment } from 'react';
import { ISetDataItem } from '@type/index';

export const Item = (props: {data: ISetDataItem}) => {
    const { data } = props || {};
    const { link, startTime, endTime, title, label, summary, color } = data || {};
    
    const Title = () => {
        return <Fragment>
            <h3>{title}</h3>
            {label ? <span className="timetable-item-label">{label}</span> : <Fragment />}
        </Fragment>;
    };

    return <li className="timetable-item">
        <div className="timetable-item-wrap">                            
            <div className="timetable-item-time">
                <span className="bullet" style={color ? {backgroundColor: color} : undefined}></span>
                {startTime && endTime ? <p>{startTime}-{endTime}</p> : <Fragment />}
            </div>
            <div className="timetable-item-content">
                <div className="timetable-item-title">
                    {link ? <a href={link} data-contents="일정표_상세일정_클릭"><Title /></a> : <Title />}
                </div>
                <div className="timetable-item-summary">{summary}</div>
            </div>
        </div>
    </li>;
};